<template>
	<PlusIcon :class="['w-6 h-6 border-2 rounded', selected ? 'border-mx-orange' : 'border-mx-gray-500 dark:border-mx-gray-400']" />
</template>

<script setup lang="ts">
import { PlusIcon } from '@heroicons/vue/24/outline'

defineProps({
	selected: {
		type: Boolean,
		default: false
	}
})
</script>
